import ViewMore from 'src/layouts/common/Projects/components/ProjectCard/components/common/ScenarioEditForm/ViewMore/ViewMore';

export default ViewMore;